export const depoimentosComunidade = [
  {
    id: 1,
    nome: 'Mariana Costa',
    cidade: 'São Paulo, SP',
    trecho: 'Querida eu do futuro, sei que você conquistou tudo aquilo que hoje parece tão distante. Você encontrou coragem para mudar de carreira e hoje acorda todos os dias com propósito.',
    avatar: 'https://public.readdy.ai/ai/img_res/80a2da7ee0c2a1a94a33a066be44cd81.jpg',
    likes: 47,
    data: '12 Jan 2025',
    plano: 'premium',
  },
  {
    id: 2,
    nome: 'Pedro Henrique',
    cidade: 'Rio de Janeiro, RJ',
    trecho: 'Eu do futuro, você finalmente aprendeu a dizer não sem culpa. Você entendeu que cuidar de si mesmo não é egoísmo, é sobrevivência. Estou orgulhoso de quem você se tornou.',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20young%20brazilian%20man%20portrait%20with%20warm%20golden%20lighting%2C%20sophisticated%20confident%20expression%2C%20dark%20luxurious%20background%20with%20subtle%20gold%20bokeh%2C%20high%20fashion%20editorial%20style%20photography&width=100&height=100&seq=comunidade-avatar-002&orientation=squarish',
    likes: 32,
    data: '08 Jan 2025',
    plano: 'gratuito',
  },
  {
    id: 3,
    nome: 'Camila Ferreira',
    cidade: 'Belo Horizonte, MG',
    trecho: 'Para a Camila de daqui a um ano: você está morando naquele apartamento com vista para as montanhas. Cada manhã é um presente. Você merece toda essa paz.',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20mature%20brazilian%20woman%20portrait%20with%20warm%20golden%20lighting%2C%20serene%20confident%20expression%2C%20dark%20luxurious%20background%20with%20subtle%20gold%20bokeh%2C%20high%20fashion%20editorial%20photography&width=100&height=100&seq=comunidade-avatar-003&orientation=squarish',
    likes: 58,
    data: '05 Jan 2025',
    plano: 'premium',
  },
  {
    id: 4,
    nome: 'Lucas Almeida',
    cidade: 'Curitiba, PR',
    trecho: 'Futuro eu, lembra daquele medo de falar em público? Pois é, você superou. Hoje você inspira centenas de pessoas com suas palavras. Continue brilhando.',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20young%20brazilian%20man%20with%20beard%20portrait%20warm%20golden%20lighting%2C%20sophisticated%20confident%20smile%2C%20dark%20luxurious%20background%20with%20gold%20tones%2C%20editorial%20style%20photography&width=100&height=100&seq=comunidade-avatar-004&orientation=squarish',
    likes: 41,
    data: '02 Jan 2025',
    plano: 'gratuito',
  },
  {
    id: 5,
    nome: 'Isabela Rodrigues',
    cidade: 'Florianópolis, SC',
    trecho: 'Querida Isa do futuro, você finalmente se permitiu ser feliz sem precisar da aprovação dos outros. Sua liberdade emocional é o maior tesouro que conquistou.',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20young%20brazilian%20woman%20with%20curly%20hair%20portrait%20warm%20golden%20lighting%2C%20joyful%20confident%20expression%2C%20dark%20luxurious%20background%20with%20gold%20bokeh%2C%20editorial%20photography&width=100&height=100&seq=comunidade-avatar-005&orientation=squarish',
    likes: 63,
    data: '28 Dez 2024',
    plano: 'premium',
  },
  {
    id: 6,
    nome: 'Thiago Nascimento',
    cidade: 'Salvador, BA',
    trecho: 'Eu do futuro, você voltou a tocar violão todas as noites. A música que estava adormecida dentro de você acordou. E com ela, sua alma inteira renasceu.',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20brazilian%20man%20portrait%20with%20warm%20golden%20lighting%2C%20creative%20artistic%20expression%2C%20dark%20luxurious%20background%20with%20subtle%20gold%20tones%2C%20high%20end%20editorial%20photography&width=100&height=100&seq=comunidade-avatar-006&orientation=squarish',
    likes: 29,
    data: '25 Dez 2024',
    plano: 'gratuito',
  },
];

export const estatisticasComunidade = {
  totalCartas: 3247,
  totalConvites: 1856,
  totalPaises: 12,
  totalCidades: 187,
};

export const rankingComunidade = [
  {
    id: 1,
    nome: 'Juliana Martins',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20brazilian%20woman%20portrait%20with%20warm%20golden%20lighting%2C%20confident%20radiant%20smile%2C%20dark%20luxurious%20background%20with%20gold%20bokeh%2C%20high%20fashion%20editorial%20photography%2C%20soft%20warm%20skin%20tones&width=100&height=100&seq=ranking-avatar-001&orientation=squarish',
    cidade: 'São Paulo, SP',
    convites: 87,
    cartasCriadas: 42,
    nivel: 'Embaixadora',
    badge: 'ri-vip-crown-2-fill',
    posicao: 1,
  },
  {
    id: 2,
    nome: 'Rafael Oliveira',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20brazilian%20man%20portrait%20with%20warm%20golden%20lighting%2C%20charismatic%20confident%20expression%2C%20dark%20luxurious%20background%20with%20subtle%20gold%20tones%2C%20editorial%20style%20photography&width=100&height=100&seq=ranking-avatar-002&orientation=squarish',
    cidade: 'Rio de Janeiro, RJ',
    convites: 64,
    cartasCriadas: 31,
    nivel: 'Embaixador',
    badge: 'ri-vip-crown-2-fill',
    posicao: 2,
  },
  {
    id: 3,
    nome: 'Fernanda Lima',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20young%20brazilian%20woman%20with%20straight%20hair%20portrait%20warm%20golden%20lighting%2C%20serene%20confident%20smile%2C%20dark%20luxurious%20background%20with%20gold%20accents%2C%20editorial%20photography&width=100&height=100&seq=ranking-avatar-003&orientation=squarish',
    cidade: 'Curitiba, PR',
    convites: 53,
    cartasCriadas: 28,
    nivel: 'Inspiradora',
    badge: 'ri-medal-fill',
    posicao: 3,
  },
  {
    id: 4,
    nome: 'Bruno Carvalho',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20brazilian%20man%20with%20glasses%20portrait%20warm%20golden%20lighting%2C%20intellectual%20confident%20expression%2C%20dark%20luxurious%20background%20with%20gold%20tones%2C%20editorial%20photography&width=100&height=100&seq=ranking-avatar-004&orientation=squarish',
    cidade: 'Belo Horizonte, MG',
    convites: 41,
    cartasCriadas: 19,
    nivel: 'Inspirador',
    badge: 'ri-medal-fill',
    posicao: 4,
  },
  {
    id: 5,
    nome: 'Ana Beatriz Santos',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20young%20brazilian%20woman%20portrait%20with%20warm%20golden%20lighting%2C%20gentle%20warm%20smile%2C%20dark%20luxurious%20background%20with%20subtle%20gold%20bokeh%2C%20editorial%20photography&width=100&height=100&seq=ranking-avatar-005&orientation=squarish',
    cidade: 'Florianópolis, SC',
    convites: 38,
    cartasCriadas: 17,
    nivel: 'Motivadora',
    badge: 'ri-award-fill',
    posicao: 5,
  },
  {
    id: 6,
    nome: 'Diego Ferreira',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20brazilian%20man%20portrait%20with%20warm%20golden%20lighting%2C%20friendly%20confident%20smile%2C%20dark%20luxurious%20background%20with%20gold%20accents%2C%20editorial%20style%20photography&width=100&height=100&seq=ranking-avatar-006&orientation=squarish',
    cidade: 'Salvador, BA',
    convites: 29,
    cartasCriadas: 14,
    nivel: 'Motivador',
    badge: 'ri-award-fill',
    posicao: 6,
  },
  {
    id: 7,
    nome: 'Larissa Mendes',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20brazilian%20woman%20with%20curly%20hair%20portrait%20warm%20golden%20lighting%2C%20joyful%20expression%2C%20dark%20luxurious%20background%20with%20gold%20tones%2C%20editorial%20photography&width=100&height=100&seq=ranking-avatar-007&orientation=squarish',
    cidade: 'Porto Alegre, RS',
    convites: 22,
    cartasCriadas: 11,
    nivel: 'Semeadora',
    badge: 'ri-seedling-fill',
    posicao: 7,
  },
  {
    id: 8,
    nome: 'Matheus Costa',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20young%20brazilian%20man%20portrait%20with%20warm%20golden%20lighting%2C%20thoughtful%20confident%20expression%2C%20dark%20luxurious%20background%20with%20gold%20bokeh%2C%20editorial%20photography&width=100&height=100&seq=ranking-avatar-008&orientation=squarish',
    cidade: 'Recife, PE',
    convites: 18,
    cartasCriadas: 9,
    nivel: 'Semeador',
    badge: 'ri-seedling-fill',
    posicao: 8,
  },
  {
    id: 9,
    nome: 'Carolina Ribeiro',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20mature%20brazilian%20woman%20portrait%20with%20warm%20golden%20lighting%2C%20wise%20confident%20smile%2C%20dark%20luxurious%20background%20with%20subtle%20gold%20accents%2C%20editorial%20photography&width=100&height=100&seq=ranking-avatar-009&orientation=squarish',
    cidade: 'Brasília, DF',
    convites: 15,
    cartasCriadas: 7,
    nivel: 'Semeadora',
    badge: 'ri-seedling-fill',
    posicao: 9,
  },
  {
    id: 10,
    nome: 'Gustavo Almeida',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20brazilian%20man%20portrait%20with%20warm%20golden%20lighting%2C%20calm%20confident%20expression%2C%20dark%20luxurious%20background%20with%20gold%20tones%2C%20editorial%20style%20photography&width=100&height=100&seq=ranking-avatar-010&orientation=squarish',
    cidade: 'Campinas, SP',
    convites: 12,
    cartasCriadas: 5,
    nivel: 'Iniciante',
    badge: 'ri-star-fill',
    posicao: 10,
  },
];

export const niveisGamificacao = [
  {
    nivel: 'Iniciante',
    icon: 'ri-star-fill',
    minConvites: 0,
    maxConvites: 9,
    cor: 'from-stone-400 to-stone-500',
    corTexto: 'text-stone-500',
    corBg: 'bg-stone-500/10',
    corBorda: 'border-stone-400/20',
    descricao: 'Comece sua jornada convidando amigos',
  },
  {
    nivel: 'Semeador(a)',
    icon: 'ri-seedling-fill',
    minConvites: 10,
    maxConvites: 24,
    cor: 'from-emerald-500 to-emerald-600',
    corTexto: 'text-emerald-500',
    corBg: 'bg-emerald-500/10',
    corBorda: 'border-emerald-400/20',
    descricao: 'Você está plantando sementes de transformação',
  },
  {
    nivel: 'Motivador(a)',
    icon: 'ri-award-fill',
    minConvites: 25,
    maxConvites: 49,
    cor: 'from-amber-500 to-amber-600',
    corTexto: 'text-amber-500',
    corBg: 'bg-amber-500/10',
    corBorda: 'border-amber-400/20',
    descricao: 'Sua energia inspira quem está ao redor',
  },
  {
    nivel: 'Inspirador(a)',
    icon: 'ri-medal-fill',
    minConvites: 50,
    maxConvites: 74,
    cor: 'from-gold-500 to-gold-600',
    corTexto: 'text-gold-500',
    corBg: 'bg-gold-500/10',
    corBorda: 'border-gold-400/20',
    descricao: 'Você é referência na comunidade',
  },
  {
    nivel: 'Embaixador(a)',
    icon: 'ri-vip-crown-2-fill',
    minConvites: 75,
    maxConvites: 999,
    cor: 'from-gold-400 to-gold-600',
    corTexto: 'text-gold-400',
    corBg: 'bg-gold-400/10',
    corBorda: 'border-gold-400/30',
    descricao: 'Elite da comunidade — líder transformador',
  },
];

export const recompensasGamificacao = [
  {
    convitesNecessarios: 5,
    titulo: 'Carta Premium Grátis',
    descricao: 'Ganhe 1 carta premium sem custo',
    icon: 'ri-gift-fill',
    conquistado: true,
  },
  {
    convitesNecessarios: 15,
    titulo: 'Badge Exclusivo',
    descricao: 'Badge dourado no seu perfil',
    icon: 'ri-shield-star-fill',
    conquistado: true,
  },
  {
    convitesNecessarios: 30,
    titulo: 'Acesso Antecipado',
    descricao: 'Novidades antes de todos',
    icon: 'ri-rocket-fill',
    conquistado: false,
  },
  {
    convitesNecessarios: 50,
    titulo: 'Meditação Exclusiva',
    descricao: 'Áudio guiado especial para membros',
    icon: 'ri-headphone-fill',
    conquistado: false,
  },
  {
    convitesNecessarios: 75,
    titulo: 'Status Embaixador',
    descricao: 'Coroa dourada e destaque no ranking',
    icon: 'ri-vip-crown-2-fill',
    conquistado: false,
  },
];

export const perfilPublicoMembros: Record<number, {
  id: number;
  nome: string;
  avatar: string;
  cidade: string;
  bio: string;
  membroDesde: string;
  convites: number;
  cartasCriadas: number;
  nivel: string;
  badge: string;
  posicao: number;
  proximoNivel: string;
  progressoNivel: number;
  convitesParaProximo: number;
  conquistas: Array<{
    titulo: string;
    descricao: string;
    icon: string;
    data: string;
    desbloqueado: boolean;
  }>;
  atividadesRecentes: Array<{
    tipo: 'conquista' | 'nivel' | 'convite' | 'carta';
    titulo: string;
    descricao: string;
    data: string;
    pontos: number;
  }>;
  estatisticas: {
    cartasPremium: number;
    cartasGratuitas: number;
    diasNaComunidade: number;
    sequenciaConvites: number;
    melhorMes: string;
    convitesMelhorMes: number;
  };
}> = {
  1: {
    id: 1,
    nome: 'Juliana Martins',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20brazilian%20woman%20portrait%20with%20warm%20golden%20lighting%2C%20confident%20radiant%20smile%2C%20dark%20luxurious%20background%20with%20gold%20bokeh%2C%20high%20fashion%20editorial%20photography%2C%20soft%20warm%20skin%20tones&width=200&height=200&seq=perfil-pub-001&orientation=squarish',
    cidade: 'São Paulo, SP',
    bio: 'Apaixonada por desenvolvimento pessoal e transformação humana. Acredito que cada carta escrita é uma semente de mudança plantada no universo. Minha missão é inspirar o máximo de pessoas a se conectarem com seu eu futuro.',
    membroDesde: 'Outubro 2024',
    convites: 87,
    cartasCriadas: 42,
    nivel: 'Embaixadora',
    badge: 'ri-vip-crown-2-fill',
    posicao: 1,
    proximoNivel: 'Nível Máximo',
    progressoNivel: 100,
    convitesParaProximo: 0,
    conquistas: [
      { titulo: 'Carta Premium Grátis', descricao: 'Conquistou com 5 convites', icon: 'ri-gift-fill', data: 'Nov 2024', desbloqueado: true },
      { titulo: 'Badge Exclusivo', descricao: 'Conquistou com 15 convites', icon: 'ri-shield-star-fill', data: 'Nov 2024', desbloqueado: true },
      { titulo: 'Acesso Antecipado', descricao: 'Conquistou com 30 convites', icon: 'ri-rocket-fill', data: 'Dez 2024', desbloqueado: true },
      { titulo: 'Meditação Exclusiva', descricao: 'Conquistou com 50 convites', icon: 'ri-headphone-fill', data: 'Dez 2024', desbloqueado: true },
      { titulo: 'Status Embaixador', descricao: 'Conquistou com 75 convites', icon: 'ri-vip-crown-2-fill', data: 'Jan 2025', desbloqueado: true },
      { titulo: 'Primeira Carta', descricao: 'Escreveu a primeira carta', icon: 'ri-quill-pen-fill', data: 'Out 2024', desbloqueado: true },
    ],
    atividadesRecentes: [
      { tipo: 'convite', titulo: 'Novos convites aceitos', descricao: '3 amigos aceitaram o convite', data: '2 dias atrás', pontos: 30 },
      { tipo: 'conquista', titulo: 'Status Embaixador', descricao: 'Alcançou o nível máximo da comunidade', data: '5 dias atrás', pontos: 500 },
      { tipo: 'carta', titulo: 'Nova carta criada', descricao: 'Escreveu sua 42ª carta para o eu futuro', data: '1 semana atrás', pontos: 20 },
      { tipo: 'nivel', titulo: 'Subiu de nível', descricao: 'De Inspiradora para Embaixadora', data: '2 semanas atrás', pontos: 200 },
      { tipo: 'convite', titulo: 'Convites em massa', descricao: '8 amigos aceitaram o convite', data: '3 semanas atrás', pontos: 80 },
    ],
    estatisticas: {
      cartasPremium: 28,
      cartasGratuitas: 14,
      diasNaComunidade: 98,
      sequenciaConvites: 12,
      melhorMes: 'Dezembro 2024',
      convitesMelhorMes: 24,
    },
  },
  2: {
    id: 2,
    nome: 'Rafael Oliveira',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20brazilian%20man%20portrait%20with%20warm%20golden%20lighting%2C%20charismatic%20confident%20expression%2C%20dark%20luxurious%20background%20with%20subtle%20gold%20tones%2C%20editorial%20style%20photography&width=200&height=200&seq=perfil-pub-002&orientation=squarish',
    cidade: 'Rio de Janeiro, RJ',
    bio: 'Psicólogo e entusiasta do autoconhecimento. Uso as cartas como ferramenta terapêutica com meus pacientes e amigos. Cada convite é uma oportunidade de transformar uma vida.',
    membroDesde: 'Novembro 2024',
    convites: 64,
    cartasCriadas: 31,
    nivel: 'Embaixador',
    badge: 'ri-vip-crown-2-fill',
    posicao: 2,
    proximoNivel: 'Nível Máximo',
    progressoNivel: 100,
    convitesParaProximo: 0,
    conquistas: [
      { titulo: 'Carta Premium Grátis', descricao: 'Conquistou com 5 convites', icon: 'ri-gift-fill', data: 'Nov 2024', desbloqueado: true },
      { titulo: 'Badge Exclusivo', descricao: 'Conquistou com 15 convites', icon: 'ri-shield-star-fill', data: 'Dez 2024', desbloqueado: true },
      { titulo: 'Acesso Antecipado', descricao: 'Conquistou com 30 convites', icon: 'ri-rocket-fill', data: 'Dez 2024', desbloqueado: true },
      { titulo: 'Meditação Exclusiva', descricao: 'Conquistou com 50 convites', icon: 'ri-headphone-fill', data: 'Jan 2025', desbloqueado: true },
      { titulo: 'Status Embaixador', descricao: 'Conquistou com 75 convites', icon: 'ri-vip-crown-2-fill', data: 'Jan 2025', desbloqueado: false },
      { titulo: 'Primeira Carta', descricao: 'Escreveu a primeira carta', icon: 'ri-quill-pen-fill', data: 'Nov 2024', desbloqueado: true },
    ],
    atividadesRecentes: [
      { tipo: 'convite', titulo: 'Novos convites aceitos', descricao: '5 amigos aceitaram o convite', data: '1 dia atrás', pontos: 50 },
      { tipo: 'carta', titulo: 'Nova carta criada', descricao: 'Escreveu sua 31ª carta', data: '3 dias atrás', pontos: 20 },
      { tipo: 'nivel', titulo: 'Subiu de nível', descricao: 'De Inspirador para Embaixador', data: '1 semana atrás', pontos: 200 },
      { tipo: 'conquista', titulo: 'Meditação Exclusiva', descricao: 'Desbloqueou áudio guiado especial', data: '2 semanas atrás', pontos: 300 },
      { tipo: 'convite', titulo: 'Convites aceitos', descricao: '4 amigos aceitaram o convite', data: '3 semanas atrás', pontos: 40 },
    ],
    estatisticas: {
      cartasPremium: 22,
      cartasGratuitas: 9,
      diasNaComunidade: 72,
      sequenciaConvites: 8,
      melhorMes: 'Janeiro 2025',
      convitesMelhorMes: 19,
    },
  },
  3: {
    id: 3,
    nome: 'Fernanda Lima',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20young%20brazilian%20woman%20with%20straight%20hair%20portrait%20warm%20golden%20lighting%2C%20serene%20confident%20smile%2C%20dark%20luxurious%20background%20with%20gold%20accents%2C%20editorial%20photography&width=200&height=200&seq=perfil-pub-003&orientation=squarish',
    cidade: 'Curitiba, PR',
    bio: 'Coach de vida e escritora. As cartas para o eu futuro mudaram minha perspectiva sobre planejamento pessoal. Compartilho essa experiência com todos que posso.',
    membroDesde: 'Novembro 2024',
    convites: 53,
    cartasCriadas: 28,
    nivel: 'Inspiradora',
    badge: 'ri-medal-fill',
    posicao: 3,
    proximoNivel: 'Embaixadora',
    progressoNivel: 88,
    convitesParaProximo: 22,
    conquistas: [
      { titulo: 'Carta Premium Grátis', descricao: 'Conquistou com 5 convites', icon: 'ri-gift-fill', data: 'Nov 2024', desbloqueado: true },
      { titulo: 'Badge Exclusivo', descricao: 'Conquistou com 15 convites', icon: 'ri-shield-star-fill', data: 'Dez 2024', desbloqueado: true },
      { titulo: 'Acesso Antecipado', descricao: 'Conquistou com 30 convites', icon: 'ri-rocket-fill', data: 'Dez 2024', desbloqueado: true },
      { titulo: 'Meditação Exclusiva', descricao: 'Conquistou com 50 convites', icon: 'ri-headphone-fill', data: 'Jan 2025', desbloqueado: true },
      { titulo: 'Status Embaixador', descricao: 'Precisa de 75 convites', icon: 'ri-vip-crown-2-fill', data: '', desbloqueado: false },
      { titulo: 'Primeira Carta', descricao: 'Escreveu a primeira carta', icon: 'ri-quill-pen-fill', data: 'Nov 2024', desbloqueado: true },
    ],
    atividadesRecentes: [
      { tipo: 'conquista', titulo: 'Meditação Exclusiva', descricao: 'Desbloqueou áudio guiado especial', data: '3 dias atrás', pontos: 300 },
      { tipo: 'convite', titulo: 'Novos convites aceitos', descricao: '2 amigos aceitaram o convite', data: '5 dias atrás', pontos: 20 },
      { tipo: 'carta', titulo: 'Nova carta criada', descricao: 'Escreveu sua 28ª carta', data: '1 semana atrás', pontos: 20 },
      { tipo: 'nivel', titulo: 'Subiu de nível', descricao: 'De Motivadora para Inspiradora', data: '2 semanas atrás', pontos: 200 },
      { tipo: 'convite', titulo: 'Convites aceitos', descricao: '6 amigos aceitaram o convite', data: '1 mês atrás', pontos: 60 },
    ],
    estatisticas: {
      cartasPremium: 18,
      cartasGratuitas: 10,
      diasNaComunidade: 68,
      sequenciaConvites: 6,
      melhorMes: 'Dezembro 2024',
      convitesMelhorMes: 16,
    },
  },
  4: {
    id: 4,
    nome: 'Bruno Carvalho',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20brazilian%20man%20with%20glasses%20portrait%20warm%20golden%20lighting%2C%20intellectual%20confident%20expression%2C%20dark%20luxurious%20background%20with%20gold%20tones%2C%20editorial%20photography&width=200&height=200&seq=perfil-pub-004&orientation=squarish',
    cidade: 'Belo Horizonte, MG',
    bio: 'Professor universitário e pesquisador em neurociência. Fascinado pelo poder da escrita intencional no desenvolvimento cognitivo e emocional.',
    membroDesde: 'Dezembro 2024',
    convites: 41,
    cartasCriadas: 19,
    nivel: 'Inspirador',
    badge: 'ri-medal-fill',
    posicao: 4,
    proximoNivel: 'Embaixador',
    progressoNivel: 64,
    convitesParaProximo: 34,
    conquistas: [
      { titulo: 'Carta Premium Grátis', descricao: 'Conquistou com 5 convites', icon: 'ri-gift-fill', data: 'Dez 2024', desbloqueado: true },
      { titulo: 'Badge Exclusivo', descricao: 'Conquistou com 15 convites', icon: 'ri-shield-star-fill', data: 'Dez 2024', desbloqueado: true },
      { titulo: 'Acesso Antecipado', descricao: 'Conquistou com 30 convites', icon: 'ri-rocket-fill', data: 'Jan 2025', desbloqueado: true },
      { titulo: 'Meditação Exclusiva', descricao: 'Precisa de 50 convites', icon: 'ri-headphone-fill', data: '', desbloqueado: false },
      { titulo: 'Status Embaixador', descricao: 'Precisa de 75 convites', icon: 'ri-vip-crown-2-fill', data: '', desbloqueado: false },
      { titulo: 'Primeira Carta', descricao: 'Escreveu a primeira carta', icon: 'ri-quill-pen-fill', data: 'Dez 2024', desbloqueado: true },
    ],
    atividadesRecentes: [
      { tipo: 'convite', titulo: 'Novos convites aceitos', descricao: '3 amigos aceitaram o convite', data: '1 dia atrás', pontos: 30 },
      { tipo: 'conquista', titulo: 'Acesso Antecipado', descricao: 'Desbloqueou novidades antes de todos', data: '4 dias atrás', pontos: 200 },
      { tipo: 'carta', titulo: 'Nova carta criada', descricao: 'Escreveu sua 19ª carta', data: '1 semana atrás', pontos: 20 },
      { tipo: 'convite', titulo: 'Convites aceitos', descricao: '5 amigos aceitaram o convite', data: '2 semanas atrás', pontos: 50 },
    ],
    estatisticas: {
      cartasPremium: 12,
      cartasGratuitas: 7,
      diasNaComunidade: 45,
      sequenciaConvites: 5,
      melhorMes: 'Janeiro 2025',
      convitesMelhorMes: 14,
    },
  },
  5: {
    id: 5,
    nome: 'Ana Beatriz Santos',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20young%20brazilian%20woman%20portrait%20with%20warm%20golden%20lighting%2C%20gentle%20warm%20smile%2C%20dark%20luxurious%20background%20with%20subtle%20gold%20bokeh%2C%20editorial%20photography&width=200&height=200&seq=perfil-pub-005&orientation=squarish',
    cidade: 'Florianópolis, SC',
    bio: 'Terapeuta holística e praticante de meditação. Encontrei nas cartas uma forma poderosa de manifestação e autoconhecimento que compartilho com minha rede.',
    membroDesde: 'Dezembro 2024',
    convites: 38,
    cartasCriadas: 17,
    nivel: 'Motivadora',
    badge: 'ri-award-fill',
    posicao: 5,
    proximoNivel: 'Inspiradora',
    progressoNivel: 52,
    convitesParaProximo: 12,
    conquistas: [
      { titulo: 'Carta Premium Grátis', descricao: 'Conquistou com 5 convites', icon: 'ri-gift-fill', data: 'Dez 2024', desbloqueado: true },
      { titulo: 'Badge Exclusivo', descricao: 'Conquistou com 15 convites', icon: 'ri-shield-star-fill', data: 'Jan 2025', desbloqueado: true },
      { titulo: 'Acesso Antecipado', descricao: 'Conquistou com 30 convites', icon: 'ri-rocket-fill', data: 'Jan 2025', desbloqueado: true },
      { titulo: 'Meditação Exclusiva', descricao: 'Precisa de 50 convites', icon: 'ri-headphone-fill', data: '', desbloqueado: false },
      { titulo: 'Status Embaixador', descricao: 'Precisa de 75 convites', icon: 'ri-vip-crown-2-fill', data: '', desbloqueado: false },
      { titulo: 'Primeira Carta', descricao: 'Escreveu a primeira carta', icon: 'ri-quill-pen-fill', data: 'Dez 2024', desbloqueado: true },
    ],
    atividadesRecentes: [
      { tipo: 'carta', titulo: 'Nova carta criada', descricao: 'Escreveu sua 17ª carta', data: '2 dias atrás', pontos: 20 },
      { tipo: 'conquista', titulo: 'Acesso Antecipado', descricao: 'Desbloqueou novidades antes de todos', data: '1 semana atrás', pontos: 200 },
      { tipo: 'convite', titulo: 'Convites aceitos', descricao: '4 amigos aceitaram o convite', data: '2 semanas atrás', pontos: 40 },
      { tipo: 'nivel', titulo: 'Subiu de nível', descricao: 'De Semeadora para Motivadora', data: '3 semanas atrás', pontos: 150 },
    ],
    estatisticas: {
      cartasPremium: 10,
      cartasGratuitas: 7,
      diasNaComunidade: 42,
      sequenciaConvites: 4,
      melhorMes: 'Janeiro 2025',
      convitesMelhorMes: 12,
    },
  },
  6: {
    id: 6,
    nome: 'Diego Ferreira',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20brazilian%20man%20portrait%20with%20warm%20golden%20lighting%2C%20friendly%20confident%20smile%2C%20dark%20luxurious%20background%20with%20gold%20accents%2C%20editorial%20style%20photography&width=200&height=200&seq=perfil-pub-006&orientation=squarish',
    cidade: 'Salvador, BA',
    bio: 'Músico e produtor cultural. A arte de escrever para o futuro me conectou com minha essência criativa. Convido todos a experimentarem essa jornada.',
    membroDesde: 'Dezembro 2024',
    convites: 29,
    cartasCriadas: 14,
    nivel: 'Motivador',
    badge: 'ri-award-fill',
    posicao: 6,
    proximoNivel: 'Inspirador',
    progressoNivel: 16,
    convitesParaProximo: 21,
    conquistas: [
      { titulo: 'Carta Premium Grátis', descricao: 'Conquistou com 5 convites', icon: 'ri-gift-fill', data: 'Dez 2024', desbloqueado: true },
      { titulo: 'Badge Exclusivo', descricao: 'Conquistou com 15 convites', icon: 'ri-shield-star-fill', data: 'Jan 2025', desbloqueado: true },
      { titulo: 'Acesso Antecipado', descricao: 'Precisa de 30 convites', icon: 'ri-rocket-fill', data: '', desbloqueado: false },
      { titulo: 'Meditação Exclusiva', descricao: 'Precisa de 50 convites', icon: 'ri-headphone-fill', data: '', desbloqueado: false },
      { titulo: 'Status Embaixador', descricao: 'Precisa de 75 convites', icon: 'ri-vip-crown-2-fill', data: '', desbloqueado: false },
      { titulo: 'Primeira Carta', descricao: 'Escreveu a primeira carta', icon: 'ri-quill-pen-fill', data: 'Dez 2024', desbloqueado: true },
    ],
    atividadesRecentes: [
      { tipo: 'convite', titulo: 'Novos convites aceitos', descricao: '2 amigos aceitaram o convite', data: '3 dias atrás', pontos: 20 },
      { tipo: 'carta', titulo: 'Nova carta criada', descricao: 'Escreveu sua 14ª carta', data: '1 semana atrás', pontos: 20 },
      { tipo: 'conquista', titulo: 'Badge Exclusivo', descricao: 'Desbloqueou badge dourado no perfil', data: '2 semanas atrás', pontos: 150 },
      { tipo: 'convite', titulo: 'Convites aceitos', descricao: '3 amigos aceitaram o convite', data: '1 mês atrás', pontos: 30 },
    ],
    estatisticas: {
      cartasPremium: 8,
      cartasGratuitas: 6,
      diasNaComunidade: 38,
      sequenciaConvites: 3,
      melhorMes: 'Janeiro 2025',
      convitesMelhorMes: 10,
    },
  },
  7: {
    id: 7,
    nome: 'Larissa Mendes',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20brazilian%20woman%20with%20curly%20hair%20portrait%20warm%20golden%20lighting%2C%20joyful%20expression%2C%20dark%20luxurious%20background%20with%20gold%20tones%2C%20editorial%20photography&width=200&height=200&seq=perfil-pub-007&orientation=squarish',
    cidade: 'Porto Alegre, RS',
    bio: 'Jornalista e blogueira de bem-estar. Escrever cartas para o eu futuro virou meu ritual semanal. Compartilho essa prática com meus leitores e seguidores.',
    membroDesde: 'Dezembro 2024',
    convites: 22,
    cartasCriadas: 11,
    nivel: 'Semeadora',
    badge: 'ri-seedling-fill',
    posicao: 7,
    proximoNivel: 'Motivadora',
    progressoNivel: 80,
    convitesParaProximo: 3,
    conquistas: [
      { titulo: 'Carta Premium Grátis', descricao: 'Conquistou com 5 convites', icon: 'ri-gift-fill', data: 'Jan 2025', desbloqueado: true },
      { titulo: 'Badge Exclusivo', descricao: 'Conquistou com 15 convites', icon: 'ri-shield-star-fill', data: 'Jan 2025', desbloqueado: true },
      { titulo: 'Acesso Antecipado', descricao: 'Precisa de 30 convites', icon: 'ri-rocket-fill', data: '', desbloqueado: false },
      { titulo: 'Meditação Exclusiva', descricao: 'Precisa de 50 convites', icon: 'ri-headphone-fill', data: '', desbloqueado: false },
      { titulo: 'Status Embaixador', descricao: 'Precisa de 75 convites', icon: 'ri-vip-crown-2-fill', data: '', desbloqueado: false },
      { titulo: 'Primeira Carta', descricao: 'Escreveu a primeira carta', icon: 'ri-quill-pen-fill', data: 'Dez 2024', desbloqueado: true },
    ],
    atividadesRecentes: [
      { tipo: 'conquista', titulo: 'Badge Exclusivo', descricao: 'Desbloqueou badge dourado no perfil', data: '4 dias atrás', pontos: 150 },
      { tipo: 'convite', titulo: 'Convites aceitos', descricao: '3 amigos aceitaram o convite', data: '1 semana atrás', pontos: 30 },
      { tipo: 'carta', titulo: 'Nova carta criada', descricao: 'Escreveu sua 11ª carta', data: '2 semanas atrás', pontos: 20 },
    ],
    estatisticas: {
      cartasPremium: 6,
      cartasGratuitas: 5,
      diasNaComunidade: 35,
      sequenciaConvites: 3,
      melhorMes: 'Janeiro 2025',
      convitesMelhorMes: 9,
    },
  },
  8: {
    id: 8,
    nome: 'Matheus Costa',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20young%20brazilian%20man%20portrait%20with%20warm%20golden%20lighting%2C%20thoughtful%20confident%20expression%2C%20dark%20luxurious%20background%20with%20gold%20bokeh%2C%20editorial%20photography&width=200&height=200&seq=perfil-pub-008&orientation=squarish',
    cidade: 'Recife, PE',
    bio: 'Empreendedor e mentor de startups. Uso as cartas como ferramenta de visão de futuro nos meus mentorados. Resultados incríveis!',
    membroDesde: 'Janeiro 2025',
    convites: 18,
    cartasCriadas: 9,
    nivel: 'Semeador',
    badge: 'ri-seedling-fill',
    posicao: 8,
    proximoNivel: 'Motivador',
    progressoNivel: 53,
    convitesParaProximo: 7,
    conquistas: [
      { titulo: 'Carta Premium Grátis', descricao: 'Conquistou com 5 convites', icon: 'ri-gift-fill', data: 'Jan 2025', desbloqueado: true },
      { titulo: 'Badge Exclusivo', descricao: 'Conquistou com 15 convites', icon: 'ri-shield-star-fill', data: 'Jan 2025', desbloqueado: true },
      { titulo: 'Acesso Antecipado', descricao: 'Precisa de 30 convites', icon: 'ri-rocket-fill', data: '', desbloqueado: false },
      { titulo: 'Meditação Exclusiva', descricao: 'Precisa de 50 convites', icon: 'ri-headphone-fill', data: '', desbloqueado: false },
      { titulo: 'Status Embaixador', descricao: 'Precisa de 75 convites', icon: 'ri-vip-crown-2-fill', data: '', desbloqueado: false },
      { titulo: 'Primeira Carta', descricao: 'Escreveu a primeira carta', icon: 'ri-quill-pen-fill', data: 'Jan 2025', desbloqueado: true },
    ],
    atividadesRecentes: [
      { tipo: 'convite', titulo: 'Novos convites aceitos', descricao: '2 amigos aceitaram o convite', data: '2 dias atrás', pontos: 20 },
      { tipo: 'conquista', titulo: 'Badge Exclusivo', descricao: 'Desbloqueou badge dourado no perfil', data: '1 semana atrás', pontos: 150 },
      { tipo: 'carta', titulo: 'Nova carta criada', descricao: 'Escreveu sua 9ª carta', data: '2 semanas atrás', pontos: 20 },
    ],
    estatisticas: {
      cartasPremium: 5,
      cartasGratuitas: 4,
      diasNaComunidade: 22,
      sequenciaConvites: 2,
      melhorMes: 'Janeiro 2025',
      convitesMelhorMes: 11,
    },
  },
  9: {
    id: 9,
    nome: 'Carolina Ribeiro',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20mature%20brazilian%20woman%20portrait%20with%20warm%20golden%20lighting%2C%20wise%20confident%20smile%2C%20dark%20luxurious%20background%20with%20subtle%20gold%20accents%2C%20editorial%20photography&width=200&height=200&seq=perfil-pub-009&orientation=squarish',
    cidade: 'Brasília, DF',
    bio: 'Advogada e mediadora de conflitos. Descobri que escrever para o eu futuro é a melhor forma de resolver conflitos internos. Uma prática que recomendo a todos.',
    membroDesde: 'Janeiro 2025',
    convites: 15,
    cartasCriadas: 7,
    nivel: 'Semeadora',
    badge: 'ri-seedling-fill',
    posicao: 9,
    proximoNivel: 'Motivadora',
    progressoNivel: 33,
    convitesParaProximo: 10,
    conquistas: [
      { titulo: 'Carta Premium Grátis', descricao: 'Conquistou com 5 convites', icon: 'ri-gift-fill', data: 'Jan 2025', desbloqueado: true },
      { titulo: 'Badge Exclusivo', descricao: 'Conquistou com 15 convites', icon: 'ri-shield-star-fill', data: 'Jan 2025', desbloqueado: true },
      { titulo: 'Acesso Antecipado', descricao: 'Precisa de 30 convites', icon: 'ri-rocket-fill', data: '', desbloqueado: false },
      { titulo: 'Meditação Exclusiva', descricao: 'Precisa de 50 convites', icon: 'ri-headphone-fill', data: '', desbloqueado: false },
      { titulo: 'Status Embaixador', descricao: 'Precisa de 75 convites', icon: 'ri-vip-crown-2-fill', data: '', desbloqueado: false },
      { titulo: 'Primeira Carta', descricao: 'Escreveu a primeira carta', icon: 'ri-quill-pen-fill', data: 'Jan 2025', desbloqueado: true },
    ],
    atividadesRecentes: [
      { tipo: 'conquista', titulo: 'Badge Exclusivo', descricao: 'Desbloqueou badge dourado no perfil', data: '2 dias atrás', pontos: 150 },
      { tipo: 'convite', titulo: 'Convites aceitos', descricao: '3 amigos aceitaram o convite', data: '1 semana atrás', pontos: 30 },
      { tipo: 'carta', titulo: 'Nova carta criada', descricao: 'Escreveu sua 7ª carta', data: '2 semanas atrás', pontos: 20 },
    ],
    estatisticas: {
      cartasPremium: 4,
      cartasGratuitas: 3,
      diasNaComunidade: 18,
      sequenciaConvites: 2,
      melhorMes: 'Janeiro 2025',
      convitesMelhorMes: 8,
    },
  },
  10: {
    id: 10,
    nome: 'Gustavo Almeida',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20brazilian%20man%20portrait%20with%20warm%20golden%20lighting%2C%20calm%20confident%20expression%2C%20dark%20luxurious%20background%20with%20gold%20tones%2C%20editorial%20style%20photography&width=200&height=200&seq=perfil-pub-010&orientation=squarish',
    cidade: 'Campinas, SP',
    bio: 'Designer gráfico e artista visual. Transformo minhas cartas em obras de arte. Cada palavra escrita é um traço no quadro do meu futuro.',
    membroDesde: 'Janeiro 2025',
    convites: 12,
    cartasCriadas: 5,
    nivel: 'Semeador',
    badge: 'ri-seedling-fill',
    posicao: 10,
    proximoNivel: 'Motivador',
    progressoNivel: 13,
    convitesParaProximo: 13,
    conquistas: [
      { titulo: 'Carta Premium Grátis', descricao: 'Conquistou com 5 convites', icon: 'ri-gift-fill', data: 'Jan 2025', desbloqueado: true },
      { titulo: 'Badge Exclusivo', descricao: 'Precisa de 15 convites', icon: 'ri-shield-star-fill', data: '', desbloqueado: false },
      { titulo: 'Acesso Antecipado', descricao: 'Precisa de 30 convites', icon: 'ri-rocket-fill', data: '', desbloqueado: false },
      { titulo: 'Meditação Exclusiva', descricao: 'Precisa de 50 convites', icon: 'ri-headphone-fill', data: '', desbloqueado: false },
      { titulo: 'Status Embaixador', descricao: 'Precisa de 75 convites', icon: 'ri-vip-crown-2-fill', data: '', desbloqueado: false },
      { titulo: 'Primeira Carta', descricao: 'Escreveu a primeira carta', icon: 'ri-quill-pen-fill', data: 'Jan 2025', desbloqueado: true },
    ],
    atividadesRecentes: [
      { tipo: 'convite', titulo: 'Novos convites aceitos', descricao: '2 amigos aceitaram o convite', data: '4 dias atrás', pontos: 20 },
      { tipo: 'carta', titulo: 'Nova carta criada', descricao: 'Escreveu sua 5ª carta', data: '1 semana atrás', pontos: 20 },
      { tipo: 'conquista', titulo: 'Carta Premium Grátis', descricao: 'Desbloqueou 1 carta premium', data: '2 semanas atrás', pontos: 100 },
    ],
    estatisticas: {
      cartasPremium: 3,
      cartasGratuitas: 2,
      diasNaComunidade: 15,
      sequenciaConvites: 1,
      melhorMes: 'Janeiro 2025',
      convitesMelhorMes: 7,
    },
  },
};
